import { Text, UI, HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { TableContent } from '../../../../../../../../components/TableContent';

import { SecondCopyListItemProps } from '.';

export const SecondCopyListItemTablet: React.FC<SecondCopyListItemProps> = ({
  id,
  selected,
  onCheck,
}) => {
  return (
    <TableContent
      direction="column"
      space={Spacing['stack.xxxs']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <HStack width="100%">
        <HStack flex={1}>
          <UI.Checkbox
            testId={`second-copy-checkbox-${id}`}
            onChange={onCheck}
            options={[{ label: '', value: id }]}
            selectedValues={selected ? [id] : []}
            optionPadding={{ bottom: 0, right: 0 }}
          />
          <VStack>
            <Text color="neutral.medium">Nº Cobrança</Text>
            <Text>95226976</Text>
          </VStack>
        </HStack>
        <VStack flex={1}>
          <Text color="neutral.medium">Parcela</Text>
          <Text>95226976</Text>
        </VStack>
        <VStack flex={1}>
          <Text color="neutral.medium">Competência</Text>
          <Text>95226976</Text>
        </VStack>
        <VStack flex={1}>
          <Text color="neutral.medium">Data emissão</Text>
          <Text>95226976</Text>
        </VStack>
      </HStack>
      <HStack width="100%">
        <VStack flex={1}>
          <Text color="neutral.medium">Data vencimento</Text>
          <Text>95226976</Text>
        </VStack>
        <VStack flex={1}>
          <Text color="neutral.medium">Tipo vencimento</Text>
          <Text>95226976</Text>
        </VStack>
        <VStack flex={1}>
          <Text color="neutral.medium">Situação</Text>
          <Text>95226976</Text>
        </VStack>
        <VStack flex={1}>
          <Text color="neutral.medium">Valor</Text>
          <Text>95226976</Text>
        </VStack>
      </HStack>
    </TableContent>
  );
};
